import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../TermsAndConditionsPage/TermsAndConditionsPage.css';

/**
 * Política de cookies — SPA (antes enlazaba a /pages/cookies.html inexistente).
 * Texto orientativo; revisión legal recomendada antes de producción.
 */
const CookiePolicyPage = () => {
  useEffect(() => {
    document.title = 'Política de cookies | Always Aligners';
  }, []);

  return (
    <div className="terms-page">
      <div className="container terms-page__inner">
        <header className="terms-page__header">
          <p className="terms-page__eyebrow">Transparencia</p>
          <h1 className="terms-page__title">Política de cookies y tecnologías similares</h1>
          <p className="terms-page__meta">
            Última actualización: marzo de 2026. Complementa la{' '}
            <Link to="/privacidad">Política de privacidad</Link>. Podés gestionar cookies desde la
            configuración de tu navegador.
          </p>
        </header>

        <div className="terms-page__content">
          <section className="terms-page__section" aria-labelledby="ck-s1">
            <h2 id="ck-s1">1. Qué son las cookies</h2>
            <p>
              Las cookies son pequeños archivos que un sitio guarda en tu dispositivo para recordar
              preferencias, mantener la sesión o medir el uso. También pueden usarse tecnologías
              similares (almacenamiento local, píxeles).
            </p>
          </section>

          <section className="terms-page__section" aria-labelledby="ck-s2">
            <h2 id="ck-s2">2. Cómo las usamos en esta plataforma</h2>
            <ul className="privacy-page__list">
              <li>
                <strong>Necesarias / funcionales:</strong> por ejemplo mantener el carrito o la sesión
                cuando corresponda, y preferencias básicas de la interfaz.
              </li>
              <li>
                <strong>Seguridad:</strong> tokens o datos técnicos asociados al inicio de sesión,
                según la implementación vigente.
              </li>
              <li>
                <strong>Terceros (pagos):</strong> al pagar con Mercado Pago, su entorno puede instalar
                cookies o almacenamiento propio conforme su política. No almacenamos datos completos de
                tarjeta en nuestros servidores.
              </li>
            </ul>
          </section>

          <section className="terms-page__section" aria-labelledby="ck-s3">
            <h2 id="ck-s3">3. Cómo desactivarlas</h2>
            <p>
              Podés bloquear o borrar cookies desde tu navegador. Algunas funciones (por ejemplo
              checkout o sesión) pueden dejar de comportarse correctamente si deshabilitás cookies
              esenciales.
            </p>
          </section>

          <section className="terms-page__section" aria-labelledby="ck-s4">
            <h2 id="ck-s4">4. Contacto</h2>
            <p>
              Para consultas sobre esta política, usá los medios indicados en el pie del sitio o la{' '}
              <Link to="/privacidad">Política de privacidad</Link>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicyPage;
